module.exports = __webpack_public_path__ + "static/00017.6ef90ebc.jpg";